export default "__VITE_ASSET__b71bd0f4__"